import { recordEventWrapper } from '..';

const mobileNavigation = () => ({
  onButtonClick: (buttonLabel: string) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: 'Bottom Navigation',
      label: `mutual funds | funds category | ${buttonLabel}`
    });
  },
  onHomeIconClick: (pathType?: string) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${pathType}`,
      label: `home`
    });
  }
});

export default mobileNavigation;
